module.exports = __webpack_public_path__ + "static/media/clinician-leads-to-stroke-preview@3x.7de16a7b.png";